import { gql } from "@apollo/client";

export const CREATE_OFFERING = gql`
  mutation createOffering($params: OfferingCreateInput!) {
    createOffering(params: $params) {
      id
      title
      target
      offeringType
      price
      offerPrice
      currency
      offeringStatus
      expireAt
    }
  }
`;
